const Oi = () => <h1>oi</h1>;

export default Oi;
